import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateCustomerInput } from './UpdateCustomerInput';
import { UpdateCustomerOutput } from './UpdateCustomerOutput';

export class UpdateCustomerService extends HttpServiceBase {

  handle = (input: UpdateCustomerInput): Promise<Result<UpdateCustomerOutput> | null> => {
    const promise = this.http.put<Result<UpdateCustomerOutput>, UpdateCustomerInput>(`${this.baseUrlSislogApi}/v2/customer/${input.id}`, input);
    return promise;
  }
}